import CancelacionesListStore from './CancelacionesListStore';
import CancelacionesUploadStore from './CancelacionesUploadStore';
import CancelacionesTicketListStore from './CancelacionesTicketListStore';

const CancelacionesStore = {
  archivos: CancelacionesListStore,
  tickets: CancelacionesTicketListStore,
  upload: CancelacionesUploadStore
}

export default CancelacionesStore;